pigSpineController = {};
pigSpineController.pigs = {};
pigSpineController.initialised = false;

pigSpineController.initialise = function (displayState) {
  // Guard against multiple initialisations
  if (pigSpineController.initialised) {
    return;
  }

  // Get the dedicated pigs container (positioned between roof and fence in layout)
  const pigsContainer = resourceManager.get('mainReelsContainer:reelFrameCon:pigsContainer');
  const pigActivateParticleEmitterContainer = resourceManager.get(
    'mainReelsContainer:pigActivateParticleEmitterContainer'
  );

  // Create pig spine objects directly in the pigs container
  pigSpineController.pigs.red = resourceManager.createObject('spine', 'redPigSpine', pigsContainer, {
    name: 'RedPig',
    scaleX: 0.06,
    scaleY: 0.06,
    x: 471,
    y: 6,
  });
  pigSpineController.pigs.red.spineObject.stateData.defaultMix = 0;
  pigSpineController.pigs.red.play('Idle2', true, 0);
  pigSpineController.pigs.redLevel = 0;
  pigSpineController.pigs.redActive = false;
  pigSpineController.pigs.redDeactive = false;
  pigSpineController.pigs.redEmitter = particleManager.createEmitter(
    'redPigActivatedEmitter',
    pigActivateParticleEmitterContainer,
    pigSpineController.pigs.red.x,
    pigSpineController.pigs.red.y,
    false
  );
  pigSpineController.pigs.redEmitter.particleEmitter.emit = false;
  pigSpineController.pigs.redAnimData = {};

  // pigSpineController.pigs.redText = resourceManager.createObject('text', 'redPigLevelText', pigsContainer, {
  //   x: 471,
  //   y: -15,
  //   anchor: 0.5,
  //   text: '-1',
  //   fontDefinition: 'robotoWhite',
  //   fontOverrides: {
  //     fontSize: 30,
  //   },
  // });

  pigSpineController.pigs.green = resourceManager.createObject('spine', 'greenPigSpine', pigsContainer, {
    name: 'GreenPig',
    scaleX: 0.06,
    scaleY: 0.06,
    x: 318,
    y: 6,
  });
  pigSpineController.pigs.green.spineObject.stateData.defaultMix = 0;
  pigSpineController.pigs.green.play('Idle2', true, 0);
  pigSpineController.pigs.greenLevel = 0;
  pigSpineController.pigs.greenActive = false;
  pigSpineController.pigs.greenDeactive = false;
  pigSpineController.pigs.greenEmitter = particleManager.createEmitter(
    'greenPigActivatedEmitter',
    pigActivateParticleEmitterContainer,
    pigSpineController.pigs.green.x,
    pigSpineController.pigs.green.y,
    false
  );
  pigSpineController.pigs.greenEmitter.particleEmitter.emit = false;
  pigSpineController.pigs.greenAnimData = {};

  // pigSpineController.pigs.greenText = resourceManager.createObject('text', 'greenPigLevelText', pigsContainer, {
  //   x: 318,
  //   y: -15,
  //   anchor: 0.5,
  //   text: '-1',
  //   fontDefinition: 'robotoWhite',
  //   fontOverrides: {
  //     fontSize: 30,
  //   },
  // });

  pigSpineController.pigs.gold = resourceManager.createObject('spine', 'goldPigSpine', pigsContainer, {
    name: 'GoldPig',
    scaleX: -0.06,
    scaleY: 0.06,
    x: 661,
    y: 6,
  });
  pigSpineController.pigs.gold.spineObject.stateData.defaultMix = 0;
  pigSpineController.pigs.gold.play('Idle2', true, 0);
  pigSpineController.pigs.goldLevel = 0;
  pigSpineController.pigs.goldActive = false;
  pigSpineController.pigs.goldDeactive = false;
  pigSpineController.pigs.goldEmitter = particleManager.createEmitter(
    'goldPigActivatedEmitter',
    pigActivateParticleEmitterContainer,
    pigSpineController.pigs.gold.x,
    pigSpineController.pigs.gold.y,
    false
  );
  pigSpineController.pigs.goldEmitter.particleEmitter.emit = false;
  pigSpineController.pigs.goldAnimData = {};

  // pigSpineController.pigs.goldText = resourceManager.createObject('text', 'goldPigLevelText', pigsContainer, {
  //   x: 661,
  //   y: -15,
  //   anchor: 0.5,
  //   text: '-1',
  //   fontDefinition: 'robotoWhite',
  //   fontOverrides: {
  //     fontSize: 30,
  //   },
  // });

  pigSpineController.pigs.blue = resourceManager.createObject('spine', 'bluePigSpine', pigsContainer, {
    name: 'BluePig',
    scaleX: -0.06,
    scaleY: 0.06,
    x: 806,
    y: 6,
  });
  pigSpineController.pigs.blue.spineObject.stateData.defaultMix = 0;
  pigSpineController.pigs.blue.play('Idle2', true, 0);
  pigSpineController.pigs.blueLevel = 0;
  pigSpineController.pigs.blueActive = false;
  pigSpineController.pigs.blueDeactive = false;
  pigSpineController.pigs.blueEmitter = particleManager.createEmitter(
    'bluePigActivatedEmitter',
    pigActivateParticleEmitterContainer,
    pigSpineController.pigs.blue.x,
    pigSpineController.pigs.blue.y,
    false
  );
  pigSpineController.pigs.blueEmitter.particleEmitter.emit = false;
  pigSpineController.pigs.blueAnimData = {};

  // pigSpineController.pigs.blueText = resourceManager.createObject('text', 'bluePigLevelText', pigsContainer, {
  //   x: 806,
  //   y: -15,
  //   anchor: 0.5,
  //   text: '-1',
  //   fontDefinition: 'robotoWhite',
  //   fontOverrides: {
  //     fontSize: 30,
  //   },
  // });

  // Start the idle animations for all pigs
  pigSpineController.startIdleAnimations();

  pigSpineController.initializeSizes(displayState);

  pigSpineController.initialised = true;
};

pigSpineController.skipAllCurrentAnims = function () {
  const pigs = ['red', 'green', 'gold', 'blue'];
  pigs.forEach((pigName, index) => {
    const pig = pigSpineController.pigs[pigName];
    const animData = pigSpineController.pigs[pigName + 'AnimData'];
    if (animData.resolver) {
      console.log('pigSpineController.skipAllCurrentAnims: stopping current spine anim on ' + pigName);
      animData.resolver();
      pig.spineObject.state.timeScale = 1;
      pig.spineObject.state.clearListeners();
      pig.stop();
      pig.play('Idle2', true, 0);
    }
  });
};

// Starts the Idle2 animation on all pig spines with staggered timing
pigSpineController.startIdleAnimations = function () {
  // Start each pig's Idle2 animation with a 200ms delay between them
  const pigs = ['red', 'green', 'gold', 'blue'];
  pigs.forEach((pigName, index) => {
    const pig = pigSpineController.pigs[pigName];
    pig.spineObject.state.clearListeners();
    pig.spineObject.state.timeScale = 1;
    if (gdk.getServerParser().isRewatchMode() || gdk.getServerParser().isReplayMode()) {
      pig.play('Idle2', true, 0);
    } else {
      const delay = index * 100; // 0ms, 200ms, 400ms, 600ms
      timerManager.addTimeout(delay, () => {
        pig.play('Idle2', true, 0);
      });
    }
  });
};

// Plays the specified animation on a single pig spine
pigSpineController.playAnimation = function (pigName, animationName, loop, callback) {
  const pig = pigSpineController.pigs[pigName];
  if (pig && pig.play) {
    console.log(`pigSpineController.playAnimation ${pigName}-${animationName}`);
    pig.spineObject.state.clearListeners();
    pig.play(animationName, loop || false, 0, callback);
  }
};

// Plays the specified animation on all pig spines and executes callback when all animations complete
pigSpineController.playAnimationOnAll = function (animationName, loop, callback) {
  let completedCount = 0;
  const totalPigs = Object.keys(pigSpineController.pigs).length;

  const onComplete = function () {
    completedCount++;
    if (completedCount === totalPigs && callback) {
      callback();
    }
  };

  for (const pigName in pigSpineController.pigs) {
    if (pigSpineController.pigs.hasOwnProperty(pigName)) {
      pigSpineController.playAnimation(pigName, animationName, loop, onComplete);
    }
  }
};

// Resets all pig spines back to their idle animations
pigSpineController.resetToIdle = function () {
  pigSpineController.startIdleAnimations();
};

// Initialize pig sizes based on display levels
pigSpineController.initializeSizes = function (displayState) {
  if (!displayState) return;

  for (const pigName in pigSpineController.pigs) {
    if (pigSpineController.pigs.hasOwnProperty(pigName)) {
      const pig = pigSpineController.pigs[pigName];
      const displayLevel = displayState[pigName].displayLevelIndex;
      pigSpineController.pigs[pigName + 'Level'] = displayLevel;
      const requiredScale = pigSpineController.getRequiredScale(pigName, displayLevel);
      pig.scale.x = requiredScale.x;
      pig.scale.y = requiredScale.y;

      const pigText = pigSpineController.pigs[pigName + 'Text'];
      if (pigText) {
        pigText.setText(displayLevel);
      }
    }
  }
};

// Play Win_React animation on specified pig
pigSpineController.playActivateAnimation = async function (pigName) {
  console.log('pigSpineController.playActivateAnimation called with pigName:', pigName);

  const promises = [];
  // so we need to increase the size of the pig to level 5 in scale
  // and play the win react anim
  pigSpineController.pigs[pigName + 'Active'] = true;
  if (pigSpineController.pigs[pigName + 'Level'] < 5) {
    promises.push(pigSpineController.scaleUpAnimation(pigName, 5, false, 1));
  } else {
    // already at 5, so leave as is
  }

  pigSpineController.pigs[pigName + 'Emitter'].particleEmitter.emit = true;
  promises.push(
    pigSpineController.playAnimationAsync(pigName, 'Win_React', pigSpineController.pigs[pigName + 'AnimData'])
  );
  await Promise.all(promises);
};

pigSpineController.playDeactivateAnimation = async function (pigName) {
  console.log('pigSpineController.playDeactivateAnimation called with pigName:', pigName);

  pigSpineController.pigs[pigName + 'Deactive'] = true;
  const promises = [];
  pigSpineController.tintPig(pigName);
  promises.push(pigSpineController.scaleDownAnimation(pigName, 0, 0.8));
  await Promise.all(promises);
};

pigSpineController.tintPig = function (pigName) {
  const pig = pigSpineController.pigs[pigName];
  if (!pig) {
    // couldnt find pig
  } else {
    pig.tint = 0x777777;
  }
};

pigSpineController.unTintPig = function (pigName) {
  const pig = pigSpineController.pigs[pigName];
  if (!pig) {
    // couldnt find pig
  } else {
    pig.tint = 0xffffff;
  }
};

pigSpineController.playIncrementAnimation = async function (pigName) {
  const pig = pigSpineController.pigs[pigName];
  if (!pig) {
    // couldnt find pig
  } else {
    console.log(`pigSpineController.playIncrementAnimation ${pigName} pig, Play Progression_Increase anim`);
    await pigSpineController.playAnimationAsync(
      pigName,
      'Progression_Increase',
      pigSpineController.pigs[pigName + 'AnimData']
    );
    console.log(`pigSpineController.playIncrementAnimation ${pigName} pig, Progression_Increase anim finished`);
  }
};

// just handle a spine anim
pigSpineController.playAnimationAsync = async function (pigName, animation, animData) {
  const pig = pigSpineController.pigs[pigName];
  if (pig) {
    let resolver = null;
    const promise = new Promise((resolve) => {
      resolver = resolve;
    });

    if (animData) {
      animData.resolver = resolver;
      animData.promise = promise;
    }

    console.log(`pigSpineController.playAnimationAsync ${pigName}-${animation}`);
    pig.spineObject.state.timeScale = 1.3;
    pig.spineObject.state.clearListeners();
    pig.play(animation, false, 0, () => {
      console.log(`pigSpineController.playAnimationAsync ${pigName}-${animation} finished, now playing loop`);
      pig.spineObject.state.timeScale = 1;
      pig.play('Idle2', true, 0);
      resolver();
    });

    await promise;

    if (animData) {
      animData.resolver = undefined;
      animData.promise = undefined;
    }
  }
};

// just handle the scaling down animation
pigSpineController.scaleDownAnimation = async function (
  pigName,
  newLevel = 0,
  startScale = 1,
  duration = 0.3,
  delay = 0
) {
  const pig = pigSpineController.pigs[pigName];
  if (pig) {
    const targetScale = pigSpineController.getRequiredScale(pigName, newLevel, startScale);

    console.log(
      `pigSpineController.scaleDownAnimation for ${pigName} pig. Current scale: ${pig.scale.x}, ${pig.scale.y}. Target scale: ${targetScale.x}, ${targetScale.y}`
    );

    let resolver = null;
    const promise = new Promise((resolve) => {
      resolver = resolve;
    });

    let alreadySkipped = false;
    let hadAnUpdate = false;
    const tween = gsap.fromTo(
      pig.scale,
      {
        x: pig.scale.x,
        y: pig.scale.y,
      },
      {
        delay: delay,
        duration: duration, // 500ms
        x: targetScale.x,
        y: targetScale.y,
        ease: 'none',
        onUpdate: () => {
          if (!hadAnUpdate) {
            hadAnUpdate = true;
          } else if (!alreadySkipped && gameController.skipCurrentPiggieAnims) {
            // stake panel is shown, jump to end
            // not the best but its all i can think of at the mo
            if (tween.isActive() || tween.time() < tween.startTime()) {
              alreadySkipped = true;
              console.log(`SKIP: skipping scaleDownAnimation ${pigName} pig`);
              tween.totalProgress(1);
            }
          }
        },
        onComplete: () => {
          alreadySkipped = true;
          resolver();
        },
      }
    );

    await promise;
  }
};

pigSpineController.scaleUpAnimation = async function (pigName, newLevel, instant = false, duration = 0.2, delay = 0) {
  const pig = pigSpineController.pigs[pigName];
  if (pig) {
    const targetScale = pigSpineController.getRequiredScale(pigName, newLevel);

    console.log(
      `pigSpineController.scaleUpAnimation for ${pigName} pig. Current scale: ${pig.scale.x}, ${pig.scale.y}. Target scale: ${targetScale.x}, ${targetScale.y}`
    );
    console.log('SKIP: scaleUpAnimation instant = ' + instant);

    let resolver = null;
    const promise = new Promise((resolve) => {
      resolver = resolve;
    });

    if (instant || gameController.skipCurrentPiggieAnims) {
      pig.scale.x = targetScale.x;
      pig.scale.y = targetScale.y;
    } else {
      // now scale back up
      let alreadySkipped = false;
      let hadAnUpdate = false;
      const tween = gsap.fromTo(
        pig.scale,
        {
          x: pig.scale.x,
          y: pig.scale.y,
        },
        {
          delay: delay,
          duration: duration,
          x: targetScale.x,
          y: targetScale.y,
          ease: 'back.out(1.7)', // Nice bouncy effect
          onUpdate: () => {
            if (!hadAnUpdate) {
              hadAnUpdate = true;
            } else if (gameController.skipCurrentPiggieAnims && !alreadySkipped) {
              if (tween.isActive() || tween.time() < tween.startTime()) {
                alreadySkipped = true;
                console.log(`SKIP: skipping scaleUpAnimation ${pigName} pig`);
                tween.totalProgress(1);
              }
            }
          },
          onComplete: () => {
            alreadySkipped = true;
            resolver();
          },
        }
      );
      await promise;
    }
  }
};

pigSpineController.playShrinkAndGrowAnimation = async function (
  pigName,
  newLevel,
  instant = false,
  callback = undefined
) {
  // debug
  const pigText = pigSpineController.pigs[pigName + 'Text'];
  if (pigText) {
    pigText.setText(newLevel);
  }
  /////////////

  console.log(`pigSpineController.playShrinkAndGrowAnimation ${pigName} pig, newLevel: ${newLevel}`);
  const pig = pigSpineController.pigs[pigName];

  if (pig) {
    let winSpineAnimPromise = null;
    if (!instant && !gameController.skipCurrentPiggieAnims) {
      winSpineAnimPromise = pigSpineController.playAnimationAsync(
        pigName,
        'Win',
        pigSpineController.pigs[pigName + 'AnimData']
      );
    }

    if (pigSpineController.pigs[pigName + 'Level'] > 0) {
      if (!instant && !gameController.skipCurrentPiggieAnims) {
        await pigSpineController.scaleDownAnimation(pigName, 0, 1, 0.2, 0);
      }
    }

    await winSpineAnimPromise;

    let growSpineAnimPromise = null;
    if (!instant && !gameController.skipCurrentPiggieAnims) {
      soundManager.play('pigGrow');
      growSpineAnimPromise = pigSpineController.playAnimationAsync(
        pigName,
        'Grow',
        pigSpineController.pigs[pigName + 'AnimData']
      );
    }

    if (newLevel > 0) {
      await pigSpineController.scaleUpAnimation(
        pigName,
        newLevel,
        instant || gameController.skipCurrentPiggieAnims,
        0.2,
        0.2
      );
    }

    // this should of fullfilled ages ago
    // do we even care?
    if (!instant && !gameController.skipCurrentPiggieAnims) {
      await growSpineAnimPromise;
    }
  } else {
  }
  pigSpineController.pigs[pigName + 'Level'] = newLevel;
  if (callback) {
    callback();
  }
};

// adjust initial scale to smaller than 1 if you want the pig smaller than level 0
pigSpineController.getRequiredScale = function (pigName, newLevel, initialScale = 1) {
  const baseScale = 0.06;
  const scaleIncrease = 0.1; // 10% per level
  const pig = pigSpineController.pigs[pigName];
  const scale = { x: 1, y: 1 };
  const sign = pig.scale.x < 0 ? -1 : 1;
  const scaleFactor = initialScale + newLevel * scaleIncrease;
  const targetScale = baseScale * scaleFactor;
  scale.x = sign * targetScale;
  scale.y = targetScale;
  return scale;
};

pigSpineController.resetOnStakeChange = async function (pigName, newLevel) {
  // debug
  const pigText = pigSpineController.pigs[pigName + 'Text'];
  if (pigText) {
    pigText.setText(newLevel);
  }
  /////////////

  console.log(`pigSpineController.resetOnStakeChange ${pigName} pig, newLevel: ${newLevel}`);
  const pig = pigSpineController.pigs[pigName];
  const requiredScale = pigSpineController.getRequiredScale(pigName, newLevel);
  pig.scale.x = requiredScale.x;
  pig.scale.y = requiredScale.y;
  pigSpineController.pigs[pigName + 'Level'] = newLevel;
};

pigSpineController;

pigSpineController.resetAfterFreeSpins = async function (pigName, newLevel) {
  // debug
  const pigText = pigSpineController.pigs[pigName + 'Text'];
  if (pigText) {
    pigText.setText(newLevel);
  }
  /////////////

  if (pigSpineController.pigs[pigName + 'Deactive'] === true) {
    pigSpineController.pigs[pigName + 'Deactive'] = false;
    pigSpineController.unTintPig(pigName);
    await pigSpineController.scaleUpAnimation(pigName, newLevel, false, 0.4);
  } else if (pigSpineController.pigs[pigName + 'Active'] === true) {
    pigSpineController.pigs[pigName + 'Active'] = false;
    await pigSpineController.scaleDownAnimation(pigName, newLevel, 1, 0.4, 0);
  }
  pigSpineController.pigs[pigName + 'Level'] = newLevel;
};
